import styled from "styled-components/macro";

export const JobDiv = styled.div`
  background-color: white;
  display: flex;
  position: relative;
  width: 100%;
  text-align: center;
  margin: 0 auto 0;
  justify-content: center;
`;

export const PostTitle = styled.h1`
  font-weight: 600;
  font-size: 40px;
  line-height: 44px;
  color: #032565;
  text-align: left;
  margin-top: 30px;
  margin-bottom: 10px;
`;

export const JobBackDiv = styled.div`
  display: flex;
  justify-items: flex-start;
  width: 100%;
  margin-top: 32px;
  & > a {
    color: ${(props) => props.theme.colors.primary};
    font-size: 16px;
    line-height: 3px;
    &:hover {
      color: ${(props) => props.theme.colors.fourtly};
      & > svg path {
        stroke: ${(props) => props.theme.colors.fourtly};
        transition: 0.3s all ease;
      }
    }
    & > svg {
      transition: 0.3s all ease;
      margin-right: 8px;
      vertical-align: text-bottom;
      position: relative;
      top: 0.05em;
    }
  }
`;

export const CardVacanciesDiv = styled.div`
  transition: 0.3s all ease;
  cursor: pointer;
  border-bottom: 1px solid #dfe1eb;
  padding-left: 8px;
  padding-right: 8px;

  &:hover {
    transition: 0.3s all ease;
    background: #f6f8fd;
  }

  & > h2 {
    margin: 16px 0 8px;
    text-align: left;
    font-weight: 400;
    font-size: 20px;

    & > svg {
      float: right;
      vertical-align: text-bottom;
      transform: translateY(5px);
    }
  }
`;

export const PostVacanciesSection = styled.section`
  display: grid;
  grid-template-columns: 1fr;
  padding: 0 32px 40px;
  max-width: ${(props) => props.theme.sizes.maxWidthMainWindow};
  color: ${(props) => props.theme.colors.text};

  & > div img {
    width: 90%;
    object-fit: cover;
    margin: 12px 0 0;
    justify-self: center;
  }

  & > h1 {
    text-align: center;
  }
  & > h4 {
    margin-bottom: 40px;
  }
  & > a {
    justify-self: start;
    font-size: ${(props) => props.theme.font.sizeTitle};
    font-weight: ${(props) => props.theme.font.weightBold};
    color: ${(props) => props.theme.colors.text};
    &:hover {
      color: ${(props) => props.theme.colors.primary};
    }
  }
  & > p {
    text-align: left;
    font-size: ${(props) => props.theme.font.sizeSubTitle};
  }
`;

export const UlFragement = styled.section`
  & > ul {
    font-size: ${(props) => props.theme.font.sizeSubTitle};
    text-align: left;
  }
`;

export const Bolder = styled.div`
  font-size: ${(props) => props.theme.font.sizeSubTitle};
  font-weight: bolder;
  text-align: left;
`;
